import InvisiButton from '../InvisiButton/InvisiButton'
import Tooltip from '../Tooltip/Tooltip'
import classes from './InfoExpand.module.scss'
import { FaInfoCircle } from 'react-icons/fa'
import {
  FiChevronDown,
  FiChevronUp
} from 'react-icons/fi'

export interface Props {
  onClick: () => void
  isSelected: boolean
  label: string
  variant?: 'info' | 'arrow'
}

const InfoExpand = ({
  onClick,
  isSelected = false,
  label,
  variant = 'info'
}: Props) => {
  const arrowClasses = [
    classes.InfoExpand,
    classes.ArrowStyle
  ].filter(classStyle => classStyle).join(' ')

  const renderInfo = () => (
    <button
      aria-label={label}
      aria-selected={isSelected}
      className={classes.InfoExpand}
      onClick={onClick}
      role='tab'
      type='button'
    >
      <FaInfoCircle
        aria-hidden
        size='1.5em'
      />
    </button>
  )

  const renderArrow = () => (
    <div
      className={arrowClasses}
    >
      <InvisiButton
        aria-label={label}
        buttonProps={
          {
            'aria-selected': isSelected,
            role: 'tab'
          }
        }
        hasHoverEffect
        onClick={onClick}
      >
        {
          isSelected
            ? (
              <FiChevronUp
                aria-label='collapse-icon'
                size='16px'
              />
            )
            : (
              <FiChevronDown
                aria-label='expand-icon'
                size='16px'
              />
            )
        }
      </InvisiButton>
    </div>
  )

  return (
    <Tooltip
      label={label}
    >
      {
        variant === 'arrow'
          ? renderArrow()
          : renderInfo()
      }
    </Tooltip>
  )
}

export default InfoExpand
